import React from 'react';
import { T } from '../tokens';

export default function FlowConnector({
  index,
  active,
  expanded,
  onDragOver,
  onDrop,
}) {
  return (
    <div
      onDragEnter={(e) => {
        e.preventDefault();
        onDragOver?.(index);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDragOver?.(index);
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDrop?.(index, e);
      }}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 260,
        minHeight: expanded ? 28 : 12,
        padding: expanded ? '6px 0' : '2px 0',
        margin: expanded ? '2px 0' : 0,
        borderRadius: 999,
        background: active ? T.blueSoft : 'transparent',
        border: active ? `1.5px dashed ${T.blue}` : '1.5px dashed transparent',
        transition: 'min-height .12s ease, background .12s ease, border-color .12s ease',
        flexShrink: 0,
      }}
    >
      <svg width="24" height="28" viewBox="0 0 24 28" fill="none" aria-hidden style={{ pointerEvents: 'none' }}>
        <line x1="12" y1="0" x2="12" y2="20" stroke={T.line} strokeWidth="2" />
        <path d="M6 16L12 24L18 16" stroke={T.slateLight} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
